import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDeviceStatus } from '../../services/DeviceService';
import { DeviceStatusResponse } from '../../types/Devices';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDeviceStatus(fleetId: string, query?: string): UseQueryResult<DeviceStatusResponse> {
  return useQuery(
    ['device-status', fleetId, query],
    async (): Promise<DeviceStatusResponse> => getDeviceStatus(fleetId, query),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
    },
  );
}

export default useGetDeviceStatus;
